import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Modal, Button,
} from 'react-bootstrap';
import RequiredOpportunityOwnerSignature from '../../../../components/request-signature/RequireOpportunityOwnerSignature';
import { updateSenderEmail } from '../../../Dashboard/DashboardActions';
import EmailField from './field';
import ProgressBar from '../../../../components/progress-bar';

class EditSenderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      survey: null,
      selectedEmail: null,
      submitting: false,
      success: false,
      errors: null,
    };
    this.close = this.close.bind(this);
    this.onExited = this.onExited.bind(this);
    this.selectSender = this.selectSender.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.survey) {
      if (!this.props.survey || this.props.survey.id !== nextProps.survey.id) {
        let fromEmail = nextProps.survey.collector_email;
        if (nextProps.survey.email_from && nextProps.survey.email_from.email) {
          fromEmail = nextProps.survey.email_from.email;
        }
        this.setState({
          open: true,
          survey: nextProps.survey,
          selectedEmail: fromEmail,
        });
      }
    } else {
      this.setState({ open: false });
    }
  }

  onExited() {
    this.setState({ survey: null, success: false }, () => {
      this.props.onClose();
    });
  }

  close() {
    this.setState({ submitting: false, open: false, selectedEmail: null, errors: null });
  }

  submit() {
    const { survey, isAccount } = this.props;
    const { selectedEmail } = this.state;
    this.setState({ submitting: true });
    this.props.dispatch(updateSenderEmail(survey.collector_id, survey.object_id, survey.id, selectedEmail, isAccount))
      .then(
        () => {
          this.setState({ submitting: false, success: true });
          this.props.onSuccess(survey);
        },
        (errors) => {
          this.setState({ submitting: false, success: false, errors });
        },
      );
  }


  selectSender(selectedEmail) {
    this.setState({ selectedEmail });
  }

  renderContent() {
    const {
      survey, isAccount,
    } = this.props;
    const { selectedEmail, submitting } = this.state;
    
    if (submitting) {
      return (
        <div>
          <p />
          <ProgressBar />
          <p />
        </div>
      );
    }
    return (
      <div>
        <p>Emails to <strong>{survey.first_name} {survey.last_name}</strong> will be sent from:</p>
        <EmailField
          survey={survey}
          isAccount={isAccount}
          selectedEmail={selectedEmail}
          submitting={submitting}
          onCancel={this.close}
          onSelectEmail={this.selectSender}
        />
      </div>
    );
  }

  renderError() {
    const { errors } = this.state;
    let message = 'Internal Server Error';
    if (errors && errors.data && errors.data.message) {
      ({ message } = errors.data);
    } else if (errors && errors.statusText) {
      message = errors.statusText;
    }
    return (
      <div className="animated flash alert alert-danger">
        {message}
      </div>
    );
  }

  render() {
    const {
      open, survey, submitting, success,
      errors,
    } = this.state;
    const { isAccount } = this.props;
    const hasSurvey = survey && survey.id;
    const props = {};
    if (hasSurvey) {
      if (isAccount) {
        props.account_id = survey.object_id;
      } else {
        props.opportunity_id = survey.object_id;
      }
    }
    const hasErrors = errors !== null;
    return (
      <Modal
        show={open}
        onHide={this.close}
        onExited={this.onExited}
      >
        {hasSurvey &&
          <Modal.Header closeButton>
            <Modal.Title>Change Email Sender for {survey.first_name} {survey.last_name}</Modal.Title>
          </Modal.Header>
        }
        {open && hasSurvey &&
          <Modal.Body>
            <div>
              {!success && !hasErrors &&
                <RequiredOpportunityOwnerSignature
                  isAccount={isAccount}
                  onCancel={this.close}
                  initiative={{ id: survey.program_id, client_id: survey.client_id, defaultCollector: { collector_id: survey.collector_id } }}
                  object={survey.object}
                >
                  {this.renderContent()}
                </RequiredOpportunityOwnerSignature>
              }
              {success && <div className="animated flash alert alert-success">Sender Email updated!</div>}
              {!success && hasErrors && this.renderError()}
            </div>
          </Modal.Body>
        }
        <Modal.Footer>
          {!success && !hasErrors &&
            <div className="clearfix">
              <Button bsStyle="link" className="pull-left" onClick={this.close}>Done</Button>
              <Button
                bsStyle="primary"
                disabled={submitting}
                onClick={this.submit}
              >
                Save
              </Button>
            </div>
          }
          {(success || hasErrors) && <Button bsStyle="link" onClick={this.close}>Done</Button>}
        </Modal.Footer>
      </Modal>
    );
  }
}

EditSenderModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  survey: PropTypes.shape({
    id: PropTypes.string,
    contact_id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    collector_id: PropTypes.string,
    time_zone: PropTypes.shape({}),
    object_id: PropTypes.string,
    client_id: PropTypes.string,
    program_id: PropTypes.string,
    is_sales_rep_first: PropTypes.bool,
    collector_email: PropTypes.string,
    email_from: PropTypes.shape({
      email: PropTypes.string,
    }),
  }),
  onClose: PropTypes.func,
  isAccount: PropTypes.bool,
  onSuccess: PropTypes.func,
};
EditSenderModal.defaultProps = {
  survey: null,
  isAccount: false,
  onClose: () => {},
  onSuccess: () => {},
};
EditSenderModal.contextTypes = {
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(EditSenderModal);
